import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import ActionHeader from '../../../ActionHeader/ActionHeader';
import FormView from '../../../../common/Form/FormView';

const PaycycleFormView = (props) => {
  const { setViewMode, formConfig, formData, setShowForm } = props;

  const formFields = useMemo(() => {
    return formConfig.reduce((acc, item) => {
      const { fieldRefName } = item;
      let temp = { ...item };
      switch (fieldRefName) {
        case 'payrollCycleEndDay':
        case 'payrollCycleStartDay':
          temp = {
            ...temp,
            isHidden: formData?.datesForSameMonth,
          };
          break;
        default: {
          break;
        }
      }
      if (!temp.isHidden) {
        acc.push(temp);
      }
      if (temp.isHidden) {
        delete formData[temp?.fieldRefName];
      }
      return acc;
    }, []);
  }, [formData]);

  return (
    <Box>
      <Box sx={{ flexGrow: 1 }}>
        <Box mb={3} mx={-3} mt={-3}>
          <ActionHeader
            labelText={formData?.name || 'Pay Cycle'}
            editButtonText="Edit"
            onEditClick={() => setViewMode(false)}
            showSave={true}
            showBackButton
            onBackClick={() => setShowForm(false)}
          />
        </Box>
        <FormView list={formFields} info={formData} />
      </Box>
    </Box>
  );
};

export default PaycycleFormView;
